// extracted by mini-css-extract-plugin
export var boxItems = "_85-1";
export var boxItemsLg = "_85-2";
export var button = "_85-7";
export var buttonHoverless = "_85-9";
export var buttonLg = "_85-8";
export var filterGroupBox = "_85-0";
export var icon = "_85-3";
export var iconSecondary = "_85-6";
export var iconWrapper = "_85-4";
export var iconWrapperLg = "_85-5";
export var truncatedLabel = "_85-a";